import React, { useState, useEffect } from "react";
import axios from "axios";
import Moment from "react-moment";
import ReactLoading from "react-loading";
import Modal from "react-bootstrap/Modal";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  ProgressBar,
  ModalFooter,
} from "react-bootstrap";
import TablePagination from "@mui/material/TablePagination";
import exportValue from "../../apiconfig";
import Left_panel from "../Left_panel";
import Sub_header from "../Sub_header";
import "../../components/loader.css";
import Swal from "sweetalert2";
import { useNavigate, useParams } from "react-router-dom";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
const Payouts_referral_trans_list = () => {
  const payout_referral_id = useParams();
  console.log("payout_referral_id == ", payout_referral_id);
  let navigate = useNavigate();
  const [state, setState] = useState({
    isLoading: true,
    user_list: [],
    totalCompleted: 0,
    totalRecords: 0,
    create_date: "",
    settle_date: "",
    status: 0,
  });
  const [otherStates, setOtherState] = useState({
    dstatus: "",
    activePage: 1,
    rowsPerPage: 10,
    page: 0,
    total_count: 0,
    onload: true,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [paidloader, setpaidloader] = useState(false);
  const [paidstate, setpaidstate] = useState({ utr_id: "", paid_date: "" });
  const [uploadModalState, setUploadModalState] = useState({
    show: false,
    excel_fle: "",
  });
  const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
    const homeSection = document.querySelector(".home-section");
    if (homeSection) {
      homeSection.classList.toggle("sidebar-closed");
    }
  };
  React.useEffect(() => {
    getUsersList(0, true);
  }, []);
  const getUsersList = (index = 0, onLoad) => {
    setIsLoading(true);
    let full_api =
      exportValue.host +
      "/" +
      exportValue.version +
      "/" +
      exportValue.api +
      `/referral_payout_transactions_list`;
    let sendData = {
      payout_referral_id: payout_referral_id.payout_referral_id,
      dstatus: otherStates.dstatus,
      limit: otherStates.rowsPerPage,
      indexValue: index,
    };

    // if (searchfilters.searchtitle) {
    //     sendData.searchKeyword = searchfilters.searchtitle
    // }
    console.log("bb", sendData);
    axios
      .post(full_api, sendData, { headers: exportValue.headers })
      .then((res) => {
        setIsLoading(false);
        console.log("response ", res);
        console.log("otherStates ", otherStates);
        // if (index == 0 && onLoad) {
        //     setOtherState({ ...otherStates, total_count: res.data.output.length })

        // }
        let create_date = res.data.output[0].create_date;
        let settle_date = res.data.output[0].settle_date;
        let status = res.data.output[0].status;

        let transactions = res.data.output[0].transactions;
        let totalRecords = transactions.length;

        // Calculate total number of completed transactions
        let totalCompleted = transactions.reduce((count, transaction) => {
          return count + (transaction.status === 1 ? 1 : 0);
        }, 0);
        setState({
          ...state,
          user_list: res.data.output,
          totalRecords: totalRecords,
          totalCompleted: totalCompleted,
          create_date: create_date,
          settle_date: settle_date,
          status: status,
          isLoading: false,
        });
      })
      .catch((e) => {
        setIsLoading(false);
      });
  };

  const handleChange = (e) => {
    setpaidstate({ ...paidstate, [e.target.name]: e.target.value });
  };
  const markPaid = (item) => {
    setpaidloader(true);

    let full_api =
      exportValue.host +
      "/" +
      exportValue.version +
      "/" +
      exportValue.api +
      `/referral_mark_as_paid_payout`;
    let sendData = {
      payout_referral_id: payout_referral_id.payout_referral_id,
      transaction_id: item.transaction_id,
    };

    console.log("bb", sendData);
    axios
      .post(full_api, sendData, { headers: exportValue.headers })
      .then((res) => {
        if (res.data.status == true) {
          Swal.fire({
            icon: "success",
            title: "Great...",
            text: "Mark As Paid",
          });
          setpaidloader(false);
          getUsersList(0, true);
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something Went Wrong",
          });
          setpaidloader(false);
          getUsersList(0, true);
        }
      })
      .catch((e) => {
        setpaidloader(false);
      });
  };

  return (
    <div>
      <Left_panel isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />

      <section class="home-section">
        {/* <?php
               include('sub_header.php');
               ?> 
            */}
        <Sub_header />

        <section class="mt-3">
          <div class="row my-3">
            <div class="col-12 col-md">
              <div class="d-flex">
                <div class="back_btn_wrap">
                  <a href="/payouts_referral" class="back_btn">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      data-lucide="corner-up-left"
                      class="lucide lucide-corner-up-left"
                    >
                      <polyline points="9 14 4 9 9 4"></polyline>
                      <path d="M20 20v-7a4 4 0 0 0-4-4H4"></path>
                    </svg>
                  </a>
                </div>
                <div class="">
                  <h2>
                    <small>Referral Payout #</small>
                    {payout_referral_id.payout_referral_id}
                  </h2>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-3 text-end">
              <small>
                Completed: <strong>{state.totalCompleted}</strong>/
                {state.totalRecords}
              </small>
              <i class="bx bx-circle text-primary"></i>{" "}
              <small>
                Crated Date:{" "}
                <Moment format="MMM DD YYYY">
                  {new Date(state.create_date * 1000)}
                </Moment>
              </small>
            </div>
            <div class="col-12 col-md-2 text-end shipm_tablew">
              {state.status == 0 ? (
                <span class="badge bg-warning">
                  {" "}
                  <i class="fa fa-clock-o" aria-hidden="true"></i>Under
                  Processing{" "}
                </span>
              ) : (
                <span class="badge bg-success">
                  {" "}
                  <i class="fa fa-check" aria-hidden="true"></i> Completed
                </span>
              )}
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-12 col-md">
              <div class="row justify-content-end">
                <div class="col-12 col-md-2">
                  <div class="input-group me-2 me-lg-3 fmxw-400">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Search Transaction"
                    />
                    <span class="input-group-text ">
                      <svg
                        class="icon icon-xs"
                        x-description="Heroicon name: solid/search"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        aria-hidden="true"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                          clip-rule="evenodd"
                        ></path>
                      </svg>
                    </span>
                  </div>
                </div>
                <div class="col-12 col-md-2">
                  {/* <input type="text" class="form-control" id="text" placeholder="Select Customer"/> */}
                </div>
                <div class="col-12 col-md-2">
                  {/* <select class="form-select">
                <option>All Status</option>
                <option>Under Process</option>
                <option>Completed</option>
                </select> */}
                </div>
              </div>
            </div>
          </div>
          <div class="card card-body border-0 shadow table-wrapper table-responsive ">
            <table class="table table-hover  shipm_tablew">
              <thead>
                <tr>
                  <th class="border-gray-200">Transaction #</th>
                  <th class="border-gray-200">Client Name</th>
                  <th class="border-gray-200">Total Eligible Order</th>
                  <th class="border-gray-200">Total Earnings</th>
                  <th class="border-gray-200">Status</th>
                  <th class="border-gray-200">Action</th>
                </tr>
              </thead>
              <tbody>
                {state.user_list.map((sub) =>
                  sub.transactions.length > 0
                    ? sub.transactions.map((item) => (
                        <tr>
                          <td>{item.transaction_id}</td>
                          <td class="fw-700 text-primary bolder">
                            <a href="" class="text-primary">
                              {item.customer_name}
                            </a>
                          </td>
                          <td class="fw-700">
                            <a
                              href="#"
                              data-bs-toggle="modal"
                              data-bs-target="#Ref_shipments"
                            >
                              {item.total_orders}
                            </a>
                          </td>
                          <td class="fw-700 text-success">
                            ₹{item.total_earnings}
                          </td>
                          <td>
                            {item.status == 0 ? (
                              <span class="badge bg-warning">
                                {" "}
                                <i
                                  class="fa fa-clock-o"
                                  aria-hidden="true"
                                ></i>{" "}
                                Under Process
                              </span>
                            ) : (
                              <span class="badge bg-success">
                                {" "}
                                <i
                                  class="fa fa-check"
                                  aria-hidden="true"
                                ></i>{" "}
                                Completed
                              </span>
                            )}
                          </td>
                          <td>
                            {item.status == 0 && !sub.am_id && !sub.ndr_id ? (
                              paidloader ? (
                                <ReactLoading
                                  type={"spin"}
                                  color={"#000000"}
                                  height={30}
                                  width={30}
                                />
                              ) : (
                                <a
                                  onClick={(e) => markPaid(item)}
                                  class="btn btn-success  btn-sm"
                                >
                                  Mark as Paid
                                </a>
                              )
                            ) : (
                              ""
                            )}
                          </td>
                        </tr>
                      ))
                    : ""
                )}
              </tbody>
            </table>
          </div>
        </section>
      </section>
    </div>
  );
};

export default Payouts_referral_trans_list;
